import { Documents_Audit_Prop_ToString, Documents_Audit_Prop_FromColumnId_Z524259A4, AuditLogs_Actions_FromId } from "../../Shared/Shared.js";
import { some, unwrap, defaultArg, map, bind } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { uncurry2, createObj } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableContainer, TableBody, TableHead, TableSortLabel, TableCell, TableRow, Table, Collapse, ListItemText, ListItem } from "@mui/material";
import { singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { cons, ofArray, empty, singleton as singleton_1 } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { ctx as ctx_1 } from "../../Context.js";
import { useEffectOnce } from "../../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { AuditLog_$reflection } from "../../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { skeletonRows } from "../../ViewHelpers.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { actionStr } from "../../AuditLogs.js";
import { toDateAndTimeStr } from "../../Locale.js";
import { sortFn } from "../../Utils.js";

function AuditsModule_translateValue(propOpt, value) {
    if (propOpt != null) {
        if (propOpt.tag === 7) {
            return value;
        }
        else {
            return value;
        }
    }
    else {
        return value;
    }
}

function AuditsModule_translateChanges(lang, audit) {
    const action = AuditLogs_Actions_FromId(audit.Action);
    switch (action.tag) {
        case 2:
            return "";
        case 1: {
            const columnOpt = bind(Documents_Audit_Prop_FromColumnId_Z524259A4, audit.ColumnId);
            const columnName = map((prop) => Documents_Audit_Prop_ToString(lang, prop), columnOpt);
            const oldValue = AuditsModule_translateValue(columnOpt, audit.OldValue);
            const newValue = audit.NewValue;
            if (lang.tag === 1) {
                if (columnName != null) {
                    return `${columnName} from "${oldValue}" to "${newValue}"`;
                }
                else {
                    return "<missing>";
                }
            }
            else if (columnName != null) {
                return `${columnName} fra "${oldValue}" til "${newValue}"`;
            }
            else {
                return "<mangler>";
            }
        }
        default:
            if (lang.tag === 1) {
                return "Create";
            }
            else {
                return "Opprett";
            }
    }
}

export function Audits_List_259D9DD2(audits_List_259D9DD2InputProps) {
    let elems_1, elements;
    const isOpen = audits_List_259D9DD2InputProps.isOpen;
    const documentId = audits_List_259D9DD2InputProps.documentId;
    let patternInput;
    const initial = defaultArg(isOpen, false);
    patternInput = reactApi.useState(initial);
    const isOpen_1 = patternInput[0];
    return createElement("div", createObj(singleton_1((elems_1 = [MuiHelpers_createElement(ListItem, [["onClick", (_arg) => {
        patternInput[1](!isOpen_1);
    }], ["button", true], (elements = toList(delay(() => append(singleton(MuiHelpers_createElement(ListItemText, [["primary", "Endringslogg"]])), delay(() => {
        let props_1, props_3;
        return isOpen_1 ? singleton((props_1 = {}, react.createElement(ExpandLess, props_1))) : singleton((props_3 = {}, react.createElement(ExpandMore, props_3)));
    })))), ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Collapse, [["mountOnEnter", true], ["in", isOpen_1], ["children", createElement(Audits_Table_Z721C83C5, {
        documentId: documentId,
    })]])], ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

export function Audits_Table_Z721C83C5(audits_Table_Z721C83C5InputProps) {
    let elements_5, children, elements_1, elements, elements_4;
    const documentId = audits_Table_Z721C83C5InputProps.documentId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const patternInput_1 = reactApi.useState([]);
    const patternInput_2 = reactApi.useState(false);
    const asc = patternInput_2[0];
    const sortKey = reactApi.useState("EditDate")[0];
    useEffectOnce(() => {
        let properties_2;
        const url = toText(printf("/api/document/%s/audits"))(documentId);
        console.debug("Mounted document audit list");
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(AuditLog_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(AuditLog_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                patternInput_1[1](res.fields[0]);
            }
            else {
                console.error(some("Failed fetching document audits:"), res.fields[0]);
            }
            patternInput[1](false);
        });
    });
    const children_1 = singleton_1(MuiHelpers_createElement(Table, [(elements_5 = [(children = singleton_1(MuiHelpers_createElement(TableRow, [(elements_1 = [MuiHelpers_createElement(TableCell, [["children", ctx.Locale.t("Document.AuditAction")]]), MuiHelpers_createElement(TableCell, [["children", ctx.Locale.t("Document.AuditChanges")]]), MuiHelpers_createElement(TableCell, [["children", ctx.Locale.t("Document.AuditReason")]]), MuiHelpers_createElement(TableCell, [["children", ctx.Locale.t("Document.AuditUser")]]), MuiHelpers_createElement(TableCell, [(elements = [MuiHelpers_createElement(TableSortLabel, toList(delay(() => append(singleton(["onClick", (_arg_2) => {
        patternInput_2[1](!asc);
    }]), delay(() => append(singleton(["active", "EditDate" === sortKey]), delay(() => append(asc ? singleton(["direction", "asc"]) : singleton(["direction", "desc"]), delay(() => singleton(["children", ctx.Locale.t("Document.AuditDate")]))))))))))], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children))]])), MuiHelpers_createElement(TableBody, [(elements_4 = (patternInput[0] ? skeletonRows(6, 3) : map_1((audit) => {
        let elements_3;
        const action = AuditLogs_Actions_FromId(audit.Action);
        const changes = AuditsModule_translateChanges(ctx.Language, audit);
        return MuiHelpers_createElement(TableRow, [["key", audit.Id], (elements_3 = [MuiHelpers_createElement(TableCell, [["children", actionStr(ctx.Language, action)]]), MuiHelpers_createElement(TableCell, [["children", changes]]), MuiHelpers_createElement(TableCell, [["children", audit.ChangesText]]), MuiHelpers_createElement(TableCell, [["children", defaultArg(map((editor) => toText(printf("%s %s"))(editor.FirstName)(editor.LastName), audit.Editor), ctx.Locale.t("TheSystem"))]]), MuiHelpers_createElement(TableCell, [["children", toDateAndTimeStr(ctx.DateFnsLocale, audit.EditDate)]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
    }, sortFn(asc, sortKey)(patternInput_1[0]))), ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])]));
    return MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_1))]]);
}

